module.exports = __webpack_public_path__ + "img/icons_connect-right-or.7071c02f.svg";